import { useMemo } from 'react';
import { DEFAULT_VIEW_CHUNK_LIMIT } from 'src/graphql/entities/custom-view/constants';
import { prepareSortAttributes } from 'src/graphql/entities/custom-view/custom-view-config/utils';
import { CustomViewSorting } from 'src/graphql/entities/custom-view/custom-view.types';
import { useSearch } from 'src/graphql/entities/search/use-search';
import { ConditionInput, EntityNames } from 'src/graphql/types';

// this hook abstracts the interface required for generic custom views table
export const useConversationRecords = ({
  filters,
  sort,
  limit = DEFAULT_VIEW_CHUNK_LIMIT,
  searchTerm,
  dynamicAttributePaths,
  includeDeleted,
}: {
  filters: ConditionInput[];
  sort: CustomViewSorting;
  limit?: number;
  searchTerm?: string;
  dynamicAttributePaths?: string[];
  includeDeleted?: boolean;
}) => {
  const options = useMemo(() => {
    return {
      searchTerm: searchTerm ?? '',
      filter: filters,
      limit,
      sort: prepareSortAttributes(sort),
      entityName: EntityNames.Conversation,
      showResultsWhenEmptySearchTerm: true,
      dynamicAttributePaths,
      includeDeleted,
    };
  }, [searchTerm, filters, includeDeleted, limit, sort, dynamicAttributePaths]);

  const data = useSearch(options);

  if (!data) {
    throw new Error('Search is not configured to search for conversations');
  }

  return data;
};
